module.exports = __webpack_public_path__ + "media/images/club-logo/6-f205abe998612cbc779de17d43abce15.png";